module.exports = __webpack_public_path__ + "img/env_5.78797ff7.jpg";